import '../text-and-lang/as-text.ts';
import '../base/buttons/as-text-button.ts';
import { useShadow, useShadowStyle } from "../wcUtil.ts"
import styleText from './shared-modal-styles.css?raw';

export class AsModalSaveProject extends HTMLElement {
  private nameInput: HTMLInputElement | null = null;

  get html() {
    return /*html*/`
      <div id="save-project-panel" class="panel-content">
        <as-text class="modal-title" dict-key="modals.project.save.title" default-text="Save project"></as-text>
        <as-text class="modal-desc" default-text="Give your project a name. It will also be used as the filename when downloading."></as-text>
        <div class="input-field">
          <label class="input-label">Project name</label>
          <input id="project-name-input" type="text" class="project-name-input" placeholder="e.g. My design">
        </div>
        <div class="row option-buttons">
          <as-text-button name="cancel-save-project">Cancel</as-text-button>
          <as-text-button name="confirm-save-project">Save</as-text-button>
        </div>
      </div>
    `
  }

  connectedCallback() {
    useShadow(this, this.html)
    useShadowStyle(this, styleText, './shared-modal-styles.css')
    this.nameInput = this.shadowRoot?.querySelector('#project-name-input') ?? null;
  }

  getValue(): string {
    return this.nameInput?.value ?? '';
  }

  setValue(value: string): void {
    if (this.nameInput) this.nameInput.value = value;
  }

  reset(): void {
    this.setValue('');
  }

  focusInput(): void {
    this.nameInput?.focus();
    this.nameInput?.select();
  }
}

customElements.define("as-modal-save-project", AsModalSaveProject)
